"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _Text = _interopRequireDefault(require("../../../components/Text"));
var _Button = _interopRequireDefault(require("../../../components/Button"));
var _theme = require("../../../theme");
var _sbUtils = require("@simplybenefits/sb-utils");
var _StyledTable = _interopRequireDefault(require("../../../components/StyledTable"));
var _StyledTableRow = _interopRequireDefault(require("../../../components/StyledTableRow"));
var _StyledTableCell = _interopRequireDefault(require("../../../components/StyledTableCell"));
var _TableHead = _interopRequireDefault(require("@mui/material/TableHead/TableHead"));
var _TableBody = _interopRequireDefault(require("@mui/material/TableBody/TableBody"));
var dates = _interopRequireWildcard(require("@simplybenefits/sb-dates"));
var _CurrentTransactions = _interopRequireDefault(require("../../Invoices/Invoice/Sections/CurrentTransactions"));
var _exportToCsvFixSourceMap = require("export-to-csv-fix-source-map");
var _i18n = _interopRequireDefault(require("../../../localization/i18n"));
var _tokens = _interopRequireDefault(require("../../../localization/tokens"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * 
 * @returns benefits with translated titles
 */
var benefits = function benefits() {
  return {
    'life': {
      title: _i18n["default"].t(_tokens["default"].titles.lifeInsurance),
      volumeType: 'number'
    },
    'add': {
      title: _i18n["default"].t(_tokens["default"].titles["ad&d"]),
      volumeType: 'number'
    },
    'ltd': {
      title: _i18n["default"].t(_tokens["default"].titles.ltd),
      volumeType: 'number'
    },
    'std': {
      title: _i18n["default"].t(_tokens["default"].titles.std),
      volumeType: 'number'
    },
    'depLife': {
      title: _i18n["default"].t(_tokens["default"].titles.depLife),
      volumeType: 'text'
    },
    'ci': {
      title: _i18n["default"].t(_tokens["default"].titles.ci),
      volumeType: 'text'
    },
    'ciSpouse': {
      title: _i18n["default"].t(_tokens["default"].titles.ciSpouse),
      volumeType: 'text'
    },
    'ciChild': {
      title: _i18n["default"].t(_tokens["default"].titles.ciChild),
      volumeType: 'text'
    },
    'health': {
      title: _i18n["default"].t(_tokens["default"].titles.health),
      volumeType: 'text'
    },
    'outOfCountry': {
      title: _i18n["default"].t(_tokens["default"].titles.outOfCountry),
      volumeType: 'text'
    },
    'stopLoss': {
      title: _i18n["default"].t(_tokens["default"].titles.stopLoss),
      volumeType: 'text'
    },
    'hsa': {
      title: _i18n["default"].t(_tokens["default"].titles.hsa),
      volumeType: 'text'
    },
    'lsa': {
      title: _i18n["default"].t(_tokens["default"].titles.lsa),
      volumeType: 'text'
    },
    'costPlus': {
      title: _i18n["default"].t(_tokens["default"].titles.costPlus),
      volumeType: 'text'
    },
    'wello': {
      title: 'Wello',
      volumeType: 'text'
    },
    'efap': {
      title: _i18n["default"].t(_tokens["default"].titles.efap),
      volumeType: 'text'
    },
    'dental': {
      title: _i18n["default"].t(_tokens["default"].titles.dental),
      volumeType: 'text'
    },
    'voluntaryBenefits': {
      title: _i18n["default"].t(_tokens["default"].titles.voluntaryBenefits),
      volumeType: 'dash'
    },
    'optionalBenefits': {
      title: _i18n["default"].t(_tokens["default"].titles.optionalBenefits),
      volumeType: 'dash'
    },
    'miscPremiums': {
      title: _i18n["default"].t(_tokens["default"].titles.misc),
      volumeType: 'dash'
    },
    'totals': {
      title: 'Totals',
      volumeType: 'number'
    }
  };
};

/**
 * Represents a component displaying transaction history and allowing the download of individual receipts.
 *
 * @param {Object} props - The properties passed to the component.
 * @param {Array} props.invoices - An array of invoices for the transaction history.
 * @param {boolean} [props.showingHistoryDefault=true] - The default visibility of the transaction history.
 * @param {Function} props.getInvoice - A function to retrieve detailed information for a selected invoice.
 * @param {Function} props.downloadPDFToBrowser - A function to download the invoice PDF to the browser.
 * @param {Function} props.applyCarryForwardBalance - A function to apply the balance as a carry forward.
 * @param {Object} props.dateRange - An optional date range for the transaction history.
 *
 * @returns {JSX.Element} - The rendered component.
 */
var TransactionHistory = function TransactionHistory(props) {
  var _props$invoices = props.invoices,
    invoices = _props$invoices === void 0 ? [] : _props$invoices;
  var _useState = (0, _react.useState)({
      showingHistory: props.showingHistoryDefault !== undefined ? props.showingHistoryDefault : true,
      currentInvoice: null
    }),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    state = _useState2[0],
    setState = _useState2[1];

  /**
   * Views a selected invoice, fetches detailed information, and updates the component state accordingly.
   *
   * @async
   * @function
   * @param {Object} selectedInvoice - The selected invoice object.
   * @param {string} selectedInvoice.invoiceNum - The invoice number to fetch details for.
   */
  var _viewInvoice = /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(selectedInvoice) {
      var invoice;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return props.getInvoice(selectedInvoice.invoiceNum);
          case 2:
            invoice = _context.sent;
            setState({
              showingHistory: false,
              currentInvoice: _objectSpread(_objectSpread({}, invoice), {}, {
                meta: _objectSpread(_objectSpread({}, selectedInvoice), invoice.meta)
              })
            });
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function _viewInvoice(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  /**
   * Formats a number as currency with a dollar sign and commas as thousand separators.
   *
   * @param {number} number - The number to be formatted as currency.
   * @returns {string} - The formatted currency as a string with a dollar sign and commas.
   */
  var formatNumber = function formatNumber(number) {
    return "$".concat((number || 0).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','));
  };

  /**
   * Determines whether to show a particular benefit in the invoice based on its premium and adjustments.
   *
   * @param {string} benefit - The name of the benefit.
   * @returns {boolean|null} - Returns true if the benefit should be shown, false if not, and null for special cases.
   */
  var _determineWhetherToShow = function _determineWhetherToShow(benefit) {
    var _state$currentInvoice, _state$currentInvoice2, _state$currentInvoice3, _state$currentInvoice4, _state$currentInvoice5;
    if (benefit === "wello" && typeof ((_state$currentInvoice = state.currentInvoice.amounts[benefit]) === null || _state$currentInvoice === void 0 ? void 0 : _state$currentInvoice.premium) !== "number") {
      return null;
    }
    return benefit !== "totals" && (((_state$currentInvoice2 = state.currentInvoice.amounts[benefit]) === null || _state$currentInvoice2 === void 0 ? void 0 : _state$currentInvoice2.premium) > 0 || (((_state$currentInvoice3 = state.currentInvoice.amounts[benefit]) === null || _state$currentInvoice3 === void 0 ? void 0 : _state$currentInvoice3.adjustments) instanceof Object ? (_state$currentInvoice4 = state.currentInvoice.amounts[benefit]) === null || _state$currentInvoice4 === void 0 ? void 0 : _state$currentInvoice4.adjustments.total : ((_state$currentInvoice5 = state.currentInvoice.amounts[benefit]) === null || _state$currentInvoice5 === void 0 ? void 0 : _state$currentInvoice5.adjustments) !== 0));
  };

  /**
   * Formats a number by adding commas as thousand separators.
   *
   * @param {number} x - The number to be formatted.
   * @returns {string} - The formatted number as a string with commas.
   */
  var _numberWithCommas = function _numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  };

  /**
   * Downloads a CSV file for the specified invoice number.
   *
   * @param {string} invoiceNum - The invoice number for which the CSV is generated.
   * @returns {void}
   */
  var _downloadCSV = function _downloadCSV(invoiceNum) {
    var items = [];

    // eslint-disable-next-line no-unused-vars, array-callback-return
    Object.keys(benefits).map(function (benefit, i) {
      var benefitParams = benefits[benefit];
      var volume = '-';
      var rate = 0;
      var premium = 0;
      var adj = 0;
      var HST = 0;
      var GST = 0;
      var PST = 0;
      var RST = 0;
      if (state.currentInvoice.amounts[benefit]) {
        // this first block is to support very old legacy invoices
        if ((benefit === 'marketplace' || benefit === 'miscPremiums') && state.currentInvoice.amounts[benefit].totals) {
          premium = state.currentInvoice.amounts[benefit].totals.premium;
          HST = state.currentInvoice.amounts[benefit].totals.HST;
          GST = state.currentInvoice.amounts[benefit].totals.GST;
          PST = state.currentInvoice.amounts[benefit].totals.PST;
          RST = state.currentInvoice.amounts[benefit].totals.RST || 0;
          adj = state.currentInvoice.amounts[benefit].totals.adjustments;
          rate = state.currentInvoice.amounts[benefit].rate;
        } else {
          premium = state.currentInvoice.amounts[benefit].premium;
          HST = state.currentInvoice.amounts[benefit].HST;
          GST = state.currentInvoice.amounts[benefit].GST;
          PST = state.currentInvoice.amounts[benefit].PST;
          RST = state.currentInvoice.amounts[benefit].RST || 0;
          rate = state.currentInvoice.amounts[benefit].rate;
          if (state.currentInvoice.amounts[benefit].adjustments instanceof Object) {
            adj = state.currentInvoice.amounts[benefit].adjustments.net;
            // need to add the adjustment taxes to the overall benefit taxes
            HST += state.currentInvoice.amounts[benefit].adjustments.HST;
            GST += state.currentInvoice.amounts[benefit].adjustments.GST;
            PST += state.currentInvoice.amounts[benefit].adjustments.PST;
            RST += state.currentInvoice.amounts[benefit].adjustments.RST || 0;
          } else {
            adj = state.currentInvoice.amounts[benefit].adjustments;
          }
          if (benefitParams.volumeType === 'number') {
            volume = _numberWithCommas(Math.ceil(state.currentInvoice.amounts[benefit].volume));
          } else if (benefitParams.volumeType === 'text') {
            volume = state.currentInvoice.amounts[benefit].coverageType;
          }
        }
      }
      if (_determineWhetherToShow(benefit)) {
        items.push({
          "benefit": benefitParams.title === "Wello" ? "Maple" : benefitParams.title,
          "volume": volume,
          "rate": formatNumber(rate),
          "premium": formatNumber(premium),
          "adj": formatNumber(adj),
          "gst/hst": formatNumber(GST + HST),
          "pst": formatNumber(PST + RST),
          "totals": formatNumber(premium + GST + HST + PST + RST + adj)
        });
      }
    });
    items.push({
      "benefit": "Totals",
      "volume": "-",
      "rate": "-",
      "premium": formatNumber(state.currentInvoice.amounts.totals.premium),
      "adj": state.currentInvoice.amounts.totals.adjustments instanceof Object ? formatNumber(state.currentInvoice.amounts.totals.adjustments.net) : formatNumber(state.currentInvoice.amounts.totals.adjustments),
      "gst/hst": formatNumber(state.currentInvoice.amounts.totals.HST + state.currentInvoice.amounts.totals.GST),
      "pst": formatNumber(state.currentInvoice.amounts.totals.PST + (state.currentInvoice.amounts.totals.RST || 0)),
      "totals": formatNumber(state.currentInvoice.amounts.totals.grandTotal)
    });
    var title = "Invoice-".concat(invoiceNum);
    if (props.dateRange) {
      title += "(".concat(props.dateRange.startDate, " - ").concat(props.dateRange.endDate, ")");
    }
    var options = {
      title: title,
      fieldSeparator: ',',
      filename: "".concat(invoiceNum, "-").concat(new Date().toLocaleDateString()),
      quoteStrings: '"',
      decimalSeparator: '.',
      showLabels: true,
      showTitle: true,
      useTextFile: false,
      useBom: true,
      headers: ["Benefit/Service", "Volume", "Rate", "Premium", "Adj.", "GST/HST", "PST", "Totals"]
    };
    var csvExporter = new _exportToCsvFixSourceMap.ExportToCsv(options);
    csvExporter.generateCsv(items);
  };
  var styles = {
    contentBlock: {
      backgroundColor: _theme.colors.surface,
      boxShadow: '0 1px 2px rgba(0, 0, 0, .15)',
      display: 'block',
      margin: 'auto auto 30px auto',
      padding: '30px',
      position: 'relative',
      zIndex: 3
    },
    container: {
      display: 'flex',
      flex: 1,
      flexDirection: 'column',
      backgroundColor: _theme.colors.surface,
      position: 'relative',
      zIndex: 3,
      marginTop: 10,
      padding: "20px 30px",
      border: "1px solid ".concat(_theme.colors.lightGrey)
    },
    header: {
      display: 'flex',
      flex: 1,
      flexDirection: 'row',
      alignItems: 'center'
    }
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    style: styles.container
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: styles.header
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      flex: 1
    }
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    large: true,
    bold: true,
    margin: "0 0 10px 0"
  }, _i18n["default"].t(_tokens["default"].labels.marketplace.transactionHistory)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    light: true,
    margin: "0 0 20px 0"
  }, _i18n["default"].t(_tokens["default"].labels.marketplace.downloadReceipts))), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    color: "primary",
    customStyle: {
      height: 50,
      width: "auto",
      marginRight: 1.25,
      textTransform: "capitalize",
      fontSize: 17,
      marginBottom: "3px"
    },
    onClick: function onClick() {
      return setState({
        showingHistory: !state.showingHistory,
        currentInvoice: null
      });
    }
  }, state.showingHistory ? _i18n["default"].t(_tokens["default"].labels.marketplace.hideTransactionHistory) : _i18n["default"].t(_tokens["default"].labels.marketplace.viewTransactionHistory))), state.currentInvoice && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      flexDirection: "row",
      width: "40%"
    }
  }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    id: "download-pdf",
    transparent: true,
    customStyle: {
      height: 50,
      textTransform: "capitalize",
      fontSize: 16,
      paddingLeft: "10px",
      paddingRight: "10px",
      marginRight: "10px"
    },
    onClick: function onClick() {
      return props.downloadPDFToBrowser("MemberInvoice", "Invoice-".concat(state.currentInvoice.invoiceNum), props.dispatch, {
        invoiceNum: state.currentInvoice.invoiceNum
      });
    }
  }, _i18n["default"].t(_tokens["default"].buttons["download invoice pdf"])), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    id: "download-csv",
    transparent: true,
    customStyle: {
      height: 50,
      textTransform: "capitalize",
      fontSize: 16,
      paddingLeft: "10px",
      paddingRight: "10px"
    },
    onClick: function onClick() {
      return _downloadCSV(state.currentInvoice.invoiceNum);
    }
  }, _i18n["default"].t(_tokens["default"].buttons["download invoice csv"]))), /*#__PURE__*/_react["default"].createElement(_CurrentTransactions["default"], {
    transaction: state.currentInvoice,
    isMemberInvoice: true
  }), props.isMasterSite && /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    color: "primary",
    customStyle: {
      height: 50,
      width: 250,
      textTransform: "capitalize",
      fontSize: 16,
      marginLeft: 'auto'
    },
    onClick: function onClick() {
      return props.applyCarryForwardBalance(state.currentInvoice.meta.invoiceNum);
    }
  }, _i18n["default"].t(_tokens["default"].labels.marketplace.applyAsCarryForward))), state.showingHistory && /*#__PURE__*/_react["default"].createElement(_StyledTable["default"], {
    padding: "dense"
  }, /*#__PURE__*/_react["default"].createElement(_TableHead["default"], null, /*#__PURE__*/_react["default"].createElement(_StyledTableRow["default"], null, /*#__PURE__*/_react["default"].createElement(_StyledTableCell["default"], {
    padding: "dense",
    style: styles.tableHeading
  }, _i18n["default"].t(_tokens["default"].labels.invoices.invoiceNumber)), /*#__PURE__*/_react["default"].createElement(_StyledTableCell["default"], {
    padding: "dense",
    style: styles.tableHeading
  }, _i18n["default"].t(_tokens["default"].labels.claimSummary.date)), /*#__PURE__*/_react["default"].createElement(_StyledTableCell["default"], {
    padding: "dense",
    style: styles.tableHeading
  }, _i18n["default"].t(_tokens["default"].labels.claims.amount)), /*#__PURE__*/_react["default"].createElement(_StyledTableCell["default"], {
    padding: "dense",
    style: styles.tableHeading
  }, _i18n["default"].t(_tokens["default"].labels.status)), /*#__PURE__*/_react["default"].createElement(_StyledTableCell["default"], {
    padding: "dense",
    style: styles.tableHeading
  }))), invoices.length === 0 ? /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    light: true,
    margin: "10px 0"
  }, _i18n["default"].t(_tokens["default"].labels.marketplace.noPaymentsApplied)) : /*#__PURE__*/_react["default"].createElement(_TableBody["default"], null, invoices.map(function (invoice) {
    return /*#__PURE__*/_react["default"].createElement(_StyledTableRow["default"], {
      hover: true,
      onClick: function onClick() {
        return _viewInvoice(invoice);
      },
      key: invoice.invoiceNum
    }, /*#__PURE__*/_react["default"].createElement(_StyledTableCell["default"], {
      padding: "dense"
    }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
      medium: true,
      light: true
    }, invoice.invoiceNum)), /*#__PURE__*/_react["default"].createElement(_StyledTableCell["default"], {
      padding: "dense"
    }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
      medium: true,
      light: true
    }, invoice.dateAdded && dates.getLocalDisplay(invoice.dateAdded, 'MMM DD, YYYY'))), /*#__PURE__*/_react["default"].createElement(_StyledTableCell["default"], {
      padding: "dense"
    }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
      medium: true,
      light: true
    }, _sbUtils.helpers.formatNumber(invoice.grandTotal, 2, true))), /*#__PURE__*/_react["default"].createElement(_StyledTableCell["default"], {
      padding: "dense"
    }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
      medium: true,
      light: true
    }, invoice.status)), /*#__PURE__*/_react["default"].createElement(_StyledTableCell["default"], {
      padding: "dense"
    }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
      medium: true,
      bold: true,
      customStyle: {
        cursor: 'pointer'
      }
    }, "View")));
  }))));
};
var _default = exports["default"] = TransactionHistory;